var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowedDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02687 3V0H4.81433C2.15543 0 0 2.14903 0 4.8V13.2C0 15.851 2.15543 18 4.81433 18H10.2304C12.8893 18 15.0448 15.851 15.0448 13.2V5.58219C15.0448 5.52117 15.0425 5.46039 15.0378 5.4H11.434C10.1046 5.4 9.02687 4.32549 9.02687 3ZM5.00907 8.68665C4.76426 8.91078 4.74807 9.29034 4.97287 9.53442C5.1977 9.77847 5.57839 9.79464 5.82317 9.57048L6.9206 8.56566V11.5254C6.9206 11.8568 7.19002 12.1254 7.52239 12.1254C7.85476 12.1254 8.12418 11.8568 8.12418 11.5254V8.56566L9.22161 9.57048C9.46638 9.79464 9.84708 9.77847 10.0719 9.53442C10.2967 9.29034 10.2805 8.91078 10.0357 8.68665L7.92944 6.75807C7.69925 6.54732 7.34552 6.54732 7.11534 6.75807L5.00907 8.68665Z",
    fill: "url(#paint0_linear_320_2226)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2304 3V0.222633C10.4596 0.328554 10.6726 0.470664 10.8604 0.645468L14.28 3.82767C14.4021 3.94122 14.5109 4.06611 14.6055 4.2H11.434C10.7693 4.2 10.2304 3.66273 10.2304 3Z",
    fill: "url(#paint1_linear_320_2226)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_320_2226",
    x1: 0.000425763,
    y1: 8.99869,
    x2: 15.0464,
    y2: 8.99869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_320_2226",
    x1: 0.000425763,
    y1: 8.99869,
    x2: 15.0464,
    y2: 8.99869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowedDocument);
export default __webpack_public_path__ + "static/media/arrowed-document.a81b09ed4683eafc1e547efe92eb9290.svg";
export { ForwardRef as ReactComponent };